import React from "react";
import {Box} from "@mui/system";
import useGetCompanyAcquireCampaigns from "./hooks/useGetAcquireCampaigns";
import BasicTable from "../../../common/BasicTable";
import _ from "lodash";
import importedStyles from "../../Proactive/Utilities/templateStyles";
import CircularProgress from "@mui/material/CircularProgress";

export default function CampaignsTable({ rows, columns, totalCount, page, loading, handlePageChange, clickableRow, handleTableRowClick, handleTableCellClick }) {

    if(loading && _.isEmpty(rows)) {
        return(
            <Box sx={importedStyles.emptyContainer} mt={{ xs: '14px', sm: '20px', }}>
                <CircularProgress size={25} sx={{ color: '#003300'}}/>
            </Box>
        )
    }

    return (
        <Box mt={{ xs: '14px', sm: '20px', }}>
            <BasicTable
                rows={rows}
                columns={columns}
                totalCount={totalCount}
                handlePageChange={handlePageChange}
                page={page}
                isPaginationDisabled={loading}
                clickableRow={clickableRow}
                handleTableRowClick={handleTableRowClick}
                handleTableCellClick={handleTableCellClick}
                tableHeadStyle={styles.ellipsis}
            />
        </Box>
    );
}


const styles = {
    ellipsis: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
}